<template>
  <ClientOnly>
    <div class="space-y-5">
      <h1 class="text-cerise-red-600 font-bold text-lg lg:text-3xl">
        Accedi gratuitamente al webinar sulla genitorialità Parental Skills at
        Work.
      </h1>
      <h3 class="text-sm md:text-base">
        Un percorso di formazione online con partner autorevoli, che mette in
        luce come le competenze acquisite grazie alla relazione con i figli
        possano trasformarsi in importanti risorse
      </h3>
      <div>
        <nuxt-link :to="config.pntSkillsAtWork" target="_blank" class="shrink-0">
          <CorePrimaryButton class="md:px-4"> ACCEDI ORA </CorePrimaryButton>
        </nuxt-link>
      </div>
    </div>
    <div class="bg-white mt-8 md:mt-12">
      <div class="hidden md:flex justify-center gap-3">
        <template v-for="item in items">
          <ParentalSkillsAtWorkCard :item="item" />
        </template>
      </div>
      <div class="swiper__brands__mobile md:hidden">
        <Swiper
          :modules="[Pagination]"
          :slides-per-view="1"
          centered
          space-between="30"
          :pagination="{ clickable: true }"
          :initial-slide="1"
        >
          <SwiperSlide v-for="slide in items" class="mx-auto">
            <ParentalSkillsAtWorkCard class="mx-auto" :item="slide" is-mobile />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </ClientOnly>
</template>
<script setup>
import { Pagination } from "swiper/modules";
import { parentalSkillsAtWork } from "~/composables/parentalSkillsAtWork";

const items = parentalSkillsAtWork();
const config = useRuntimeConfig().public;
</script>
